<script>
  import { Modal } from "carbon-components-svelte";
  import Button from "./Button.svelte";
  import { Tooltip } from "paxray-components-svelte";
  import { tick } from "svelte";

  export let open;
  export let modalHeading;
  export let actions = false;
  export let subtitle = "";
  export let tooltipText = "";
  export let buttonSize = "md";
  export let width = 500;
  export let xs = false;
  export let autowidth = false;
  export let fitcontent = false;
  export let xxl = false;
  export let hasScrollingContent = true;
  export let modalClass = "";
  export let primaryButtonText = "Save";
  export let primaryButtonVariant = "primary";
  export let secondaryButtonText = "Cancel";
  export let primaryButtonValidations = false;
  export let primaryButtonNotAllow = false;
  export let noSecondaryButton = false;
  export let hideFooter = false;
  export let primaryButtonAction = () => {};
  export let preventCloseOnClickOutside = true;
  export let secondaryButtonAction = () => {
    open = false;
  };

  let modalWrapper;

  $: if (open && modalWrapper) {
    focusModal();
  }

  async function focusModal() {
    await tick();
    setTimeout(() => {
      if (modalWrapper) {
        modalWrapper.focus();
      }
    }, 10);
  }
</script>

<Modal
  class="custom-modal {xxl ? 'xxl' : ''} {modalClass}"
  bind:open
  {modalHeading}
  on:close
  passiveModal
  {hasScrollingContent}
  size={xs ? "xs" : undefined}
  {preventCloseOnClickOutside}
>
  <svelte:fragment slot="heading">
    <h3
      id="bx--modal-header__heading--modal-ccs-0.svj7woysq9"
      class="bx--modal-header__heading"
      class:with-tooltip={Boolean(tooltipText)}
    >
      {modalHeading}
      {#if tooltipText}<Tooltip text={tooltipText} />{/if}
    </h3>
    {#if subtitle}
      <p>{subtitle}</p>
    {/if}
  </svelte:fragment>
  <div
    class="modal_wrapper"
    style="width:{width}px"
    class:auto={autowidth === true}
    class:fitcontent={fitcontent === true}
    bind:this={modalWrapper}
    tabindex="-1"
    role="dialog"
    aria-modal="true"
    on:keydown={(e) => {
      if (
        e.key === "Enter" &&
        !primaryButtonNotAllow &&
        !primaryButtonValidations
      ) {
        primaryButtonAction();
      }
    }}
  >
    <div class="divider" />
    <slot />
    {#if !hideFooter}
      <div class="divider divider-margin" />
      <div class="buttons-container">
        <slot name="left-buttons" />
        <div class="actions-buttons-container">
          {#if actions}
            <!-- @Adrian irgendwas stimmt bei dem modal nicht, nutzer anlegen bugt massiv -->
            {#if !noSecondaryButton}
              <Button
                on:click={secondaryButtonAction}
                text={secondaryButtonText}
                variant="secondary"
                size={buttonSize}
                iconLeft={false}
                setting={true}
              />
            {/if}
            <slot name="action-buttons" />
            <Button
              on:click={primaryButtonAction}
              text={primaryButtonText}
              variant={primaryButtonVariant}
              size={buttonSize}
              iconLeft={false}
              setting={true}
              bind:disabled={primaryButtonValidations}
              notAllowed={primaryButtonNotAllow}
            />
          {/if}
        </div>
      </div>
    {/if}
  </div>
</Modal>

<style>
  .with-tooltip {
    display: flex;
    align-items: center;
    gap: var(--control-gap);
  }

  :global(.custom-modal .bx--modal-content) {
    /* overflow-y: initial !important; */
    margin-bottom: 0 !important;
    outline: none !important;
  }

  /* Zusammen mit dem Container-Padding ergibt das unter den Buttons
     denselben Abstand wie zwischen Trennlinie und Buttons. */
  :global(.bx--modal-scroll-content > *:last-child) {
    padding-bottom: 1rem !important;
  }

  .buttons-container {
    display: flex;
    justify-content: space-between;
    gap: 9px;
    margin-top: 1.5rem;
  }

  .actions-buttons-container {
    display: flex;
    justify-content: flex-end;
    gap: 9px;
    margin-left: auto;
  }

  .modal_wrapper:focus {
    outline: none;
  }

  /* The width prop is set inline. Clamp it so a modal can never be wider than
     the content box it sits in - otherwise a vertical scrollbar pushes the
     content out and adds a horizontal scrollbar on top. */
  .modal_wrapper {
    max-width: 100%;
    margin-inline: auto;
  }

  :global(.bx--modal-close) {
    border-radius: 0.5rem;
  }

  :global(.bx--modal-close:focus) {
    border: none;
  }

  :global(.bx--modal-container) {
    background-color: white !important;
    border-radius: 0.5rem;
    padding: 0.5rem;
    /* width: auto !important; */
    overflow: initial !important;
  }

  :global(.custom-modal.xxl .bx--modal-container) {
    width: 84% !important;
  }

  :global(.custom-modal.filter-modal .bx--modal-content) {
    max-height: none !important;
    overflow-y: visible !important;
  }

  :global(.custom-modal.filter-modal .bx--modal-container) {
    overflow: visible !important;
  }

  :global(.bx--modal-header__heading) {
    color: var(--pax-black) !important;
    font-family: Inter !important;
    font-size: 14px !important;
    font-style: normal !important;
    font-weight: 700 !important;
    line-height: normal !important;
  }

  .divider {
    width: 100%;
    height: 1px;
    background: #d9d9d9;
    margin-bottom: 1rem;
  }

  .divider-margin {
    margin-top: 1rem;
  }

  .auto {
    width: 100% !important;
  }

  .fitcontent {
    width: fit-content !important;
  }
</style>
